import Slug from '../Slug';
import { FormItem } from '../Form';
import SearchBar from '../SearchBar';
import type { Pagination } from '@/hooks/usePaginated';

// TODO: make overloads for name: search by default
type SearchPanelProps<T extends {}> = {
  name?: StringKeyOf<T> & string;
  totalCount?: number;
  pagination?: Pagination;
  disabled?: boolean;
};

const SearchPanel = <T extends {}>({
  name,
  totalCount,
  pagination,
  disabled = false,
}: SearchPanelProps<T>) => {
  return (
    <>
      <FormItem<any> name={name || 'search'} label="">
        <SearchBar disabled={disabled} />
      </FormItem>
      {(!!pagination || !!totalCount) && (
        <div className="mr-auto flex items-center gap-x-md min-w-[20rem]">
          Total Records:
          <Slug
            className="min-w-[3rem] max-w-[7rem] w-fit"
            text={totalCount || pagination?.totalItems}
          />
        </div>
      )}
    </>
  );
};

export default SearchPanel;
